export function buildQueryString<T>(params: T): string {
  const urlSearchParams = new URLSearchParams();
  for (const key in params) {
    const value = params[key as keyof T];
    if (value !== undefined && value !== null) {
      urlSearchParams.append(key, value.toString());
    }
  }
  const queryString = urlSearchParams.toString();
  return queryString ? `?${queryString}` : '';
}
